import { render, staticRenderFns } from "./SiderRoutePictures.vue?vue&type=template&id=03ecf946&scoped=true&"
import script from "./SiderRoutePictures.vue?vue&type=script&lang=js&"
export * from "./SiderRoutePictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ecf946",
  null
  
)

export default component.exports